export class IDGenerator {
    static generateID(): string {
        return `${Math.random().toString(16).slice(2)}`;
    }
}
